import {createContext} from 'react';

/**
 * Roster data shared by the People route's side nav and its child tabs. `null` until a provider
 * mounts. Each provider supplies a different subset, so only the fields all of them share are
 * required.
 */
export interface PeopleContextValue {
  classroom: unknown;
  queries: {
    coteachers: unknown;
    classroom?: unknown;
    invitations?: unknown;
    students?: unknown;
  };
  isReady?: boolean;
  invitations?: unknown;
  students?: unknown;
  teachers?: unknown;
  currentTeacherId?: string | null;
}

const PeopleContext = createContext<PeopleContextValue | null>(null);

export default PeopleContext;
